import React from 'react';
import cx from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import PropTypes from 'prop-types';

import SubscriptionTitleToProductId from '../../../../../constants/enums/SubscriptionTitleToProductId';
import getDiscountedPrice from '../../../../../helpers/getDiscountedPrice';
import { useIsScreenSize } from '../../../../../hooks/useIsScreenSize';
import Button from '../../../../Button';
import { H5, Paragraph } from '../../../../Typography';

import styles from './PackageHeaderMeteredExperiment.module.scss';

const PackageHeaderMeteredExperiment = ({
  title,
  price,
  displayMonthlyPrice,
  onButtonClick,
  preAppliedCoupon,
}) => {
  const productId = SubscriptionTitleToProductId[title];
  const isTablet = useIsScreenSize(1006);

  const discountedPrice = getDiscountedPrice(
    price,
    preAppliedCoupon,
    productId,
  );

  const displayPrice = displayMonthlyPrice ? (price / 12).toFixed(2) : price;
  const displayDiscountedPrice = displayMonthlyPrice
    ? (discountedPrice / 12).toFixed(2)
    : discountedPrice;

  const hasDiscount = discountedPrice !== price;

  const buttonText = `GET ${title.toUpperCase()}`;

  const isProPackage = title === 'Pro';

  return (
    <div
      className={cx(styles.packHeader, {
        [styles.proHeader]: !isProPackage,
        [styles.premiumHeader]: isProPackage,
        [styles.withCoupon]: !!preAppliedCoupon,
      })}
    >
      {isProPackage && (
        <div className={styles.bestValueBanner}>Most Popular</div>
      )}
      <div className={styles.packTitleWrapper}>
        <H5 className={styles.packTitle}>{title}</H5>
      </div>
      <Paragraph
        className={!displayMonthlyPrice ? styles.price : styles.monthlyPrice}
      >
        <AnimatePresence>
          {hasDiscount && (
            <motion.span
              className={styles.originalPrice}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
            >
              ${displayPrice}
            </motion.span>
          )}
        </AnimatePresence>
        <motion.span
          key={displayDiscountedPrice}
          initial={hasDiscount ? { scale: 0.8, opacity: 0 } : false}
          animate={hasDiscount ? { scale: 1, opacity: 1 } : false}
          transition={{ duration: 0.3 }}
        >
          ${displayDiscountedPrice}
        </motion.span>
        <span className={styles.per}>
          {displayMonthlyPrice ? '/ month' : 'Per year'}
        </span>
        {displayMonthlyPrice && (
          <span className={styles.annually}>Billed annually</span>
        )}
      </Paragraph>
      <Button
        className={styles.btn}
        onClick={onButtonClick}
        {...(!isProPackage ? { secondary: true } : {})}
      >
        {!isTablet ? buttonText : 'UPGRADE'}
      </Button>
    </div>
  );
};

PackageHeaderMeteredExperiment.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  displayMonthlyPrice: PropTypes.bool.isRequired,
  onButtonClick: PropTypes.func.isRequired,
  preAppliedCoupon: PropTypes.object,
};

export default PackageHeaderMeteredExperiment;
